// src/components/personal/sections/SettingsSection/SettingsSection.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
//import { Settings } from 'lucide-react';
import AppSettings from './AppSettings/AppSettings';
import { COMPONENT_STYLES } from '@/theme/components';
import { TEXT_STYLES } from '@/theme/typography';

const SettingsSection: React.FC = () => {
  // Используем правильное пространство имен с префиксом
  const { t } = useTranslation('profile');

  return (
    <div className={COMPONENT_STYLES.card.base}>
      <div className={COMPONENT_STYLES.card.header}>
        <h2 className={TEXT_STYLES.h2}>{t('settings')}</h2>
      </div>
      
      <div className={COMPONENT_STYLES.card.body}>
        <div className="mt-6">
          <AppSettings />
        </div>
      </div>
    </div>
  );
};

export default SettingsSection;